import {
  StyledAccordion,
  StyledContent as StyledAccordionContent
} from 'components/shared/accordion/Accordion.styled';
import { Button } from 'components/shared/Button';
import { StyledFormGroup } from 'components/shared/FormGroup.styled';
import { StyledInputText } from 'components/shared/InputText.styled';
import styled from 'styled-components';
import { color, fontSize, fontWeight, screen, spacing, zindex } from 'theme';

export const StyledFilters = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 260px;
  z-index: ${zindex('filters')};
  transform: translateX(100%);
  transition: transform 0.3s;
  background-color: ${color('white')};

  .showFilters & {
    transform: translateX(0);
  }

  @media (min-width: ${screen('lg')}) {
    position: static;
    width: auto;
    transform: unset;
    background-color: unset;
  }

  ${StyledAccordionContent} {
    padding: ${spacing('md')} 0;
  }
`;

export const StyledFiltersBg = styled.div`
  .showFilters & {
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: ${zindex('filtersBg')};
  }

  @media (min-width: ${screen('lg')}) {
    display: none;
  }
`;

export const StyledOfferAlertsDropdown = styled.div`
  position: relative;
`;

export const StyledFiltersTitle = styled.div`
  background-color: ${color('midnight_100')};
  padding: ${spacing('md')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('black')};

  @media (min-width: ${screen('lg')}) {
    background-color: transparent;
    padding: 0 0 ${spacing('sm')} 0;
    text-transform: uppercase;
    letter-spacing: 0.25em;
    color: ${color('text_subtle')};
    font-size: ${fontSize('xs')};
    border-bottom: 1px solid ${color('midnight_300')};

    ${Button}.close-filters {
      display: none;
    }
  }
`;

export const StyledFiltersContainer = styled.div`
  flex-grow: 1;
  padding: ${spacing('md')};
  overflow: auto;

  .filters-item:not(:last-child) {
    margin-bottom: ${spacing('lg')};
  }

  input[type='number'] {
    width: ${spacing('xl5')};
    min-width: auto;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  @media (min-width: ${screen('lg')}) {
    padding: ${spacing('lg')} 0;
    overflow: visible;
  }

  ${StyledAccordion} {
    margin-bottom: ${spacing('lg')};
  }
`;

export const StyledFiltersAction = styled.div`
  background-color: ${color('midnight_100')};
  padding: ${spacing('lg')} ${spacing('md')} ${spacing('xl3')} ${spacing('md')};
  margin-top: 0;

  ${Button} {
    display: flex;
    width: 100%;
    margin-bottom: ${spacing('sm')};

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: ${screen('lg')}) {
    background-color: transparent;
    padding: 0;
  }
`;

export const StyledListFilterSpinner = styled.div`
  align-self: center;
  width: ${spacing('xl')};
  height: ${spacing('xl')};
  background: red;
  animation: spin 0.75s linear infinite;
  border-radius: 50%;
  background: linear-gradient(
    to right,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: absolute;
  right: 0;
  bottom: 0;

  &:before {
    width: 50%;
    height: 50%;
    background: ${color('midnight_800')};
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  &:after {
    background: #fff;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledSalaryFieldset = styled.fieldset`
  padding: 0;
  border: 0;
`;

export const StyledSalaryDoubleField = styled.div`
  display: flex;

  ${StyledFormGroup} {
    width: auto;
  }

  .mf-select {
    width: 5rem;
  }
  .mf-select__control {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: 0 !important;
  }

  ${StyledInputText} {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
